module.exports = __webpack_public_path__ + "img/icon-arrow-right.cb2214d6.svg";